import { getSettings } from "./controller/getSettings"
import {
    AccordionSummary,
    Box,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableRow,
    TextField,
    Typography,
} from "@mui/material"
import { SettingsRow } from "./SettingsRow"
import { Repeat } from "lib/@components/repeat"
import { Secure } from "lib/authorization/secure"
import { Fragment, useState } from "react"
import { AuditAccordionSummary, AuditTopBarDownloadButton } from "slot-definitions"
import { replaceAllWith } from "lib/@components/slot/replace-all-with"
import { Frag } from "lib/@components/slot/frag"
import { Activity } from "routes/audit/component/activity-button"

AuditAccordionSummary("systemSettings").plug(
    replaceAllWith(
        <AccordionSummary sx={{ pointerEvents: "none" }}>
            <Typography variant={"subtitle1"}>System Settings Changes</Typography>
        </AccordionSummary>
    )
)
AuditTopBarDownloadButton("systemSettings").plug(replaceAllWith(<Frag />))

export function Settings() {
    const [searchTerm, setSearchTerm] = useState("")
    const settings = getSettings.useResultsOnce()
    return (
        <Secure demand="staff">
            {!settings && <Typography>Loading Settings</Typography>}
            {settings && <SettingsTable settings={settings} searchTerm={searchTerm} setSearchTerm={setSearchTerm} />}
        </Secure>
    )
}

export function SettingsTable({ settings, searchTerm, setSearchTerm }) {
    const settingsArray = Object.values(settings)

    const filteredSettings = settingsArray.filter((setting) =>
        Object.values(setting).some(
            (val) => typeof val === "string" && val.toLowerCase().includes(searchTerm.toLowerCase())
        )
    )

    const groupedSettings = filteredSettings.reduce((acc, setting) => {
        if (!acc[setting.category]) {
            acc[setting.category] = []
        }
        acc[setting.category].push(setting)
        return acc
    }, {})

    const categories = Object.keys(groupedSettings)

    const handleSearch = (event) => {
        setSearchTerm(event.target.value)
    }
    return (
        <TableContainer>
            <Table>
                <TableBody>
                    <TableRow>
                        <TableCell
                            colSpan={5}
                            style={{
                                fontWeight: "150%",
                                fontSize: "120%",
                                textTransform: "capitalize",
                            }}
                        >
                            <Box display="flex" alignItems="center">
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    placeholder="Filter Settings..."
                                    value={searchTerm}
                                    onChange={handleSearch}
                                />
                                <Activity type="systemSettings" passedId="systemSettings" forTypeAllClients={true} />
                            </Box>
                        </TableCell>
                    </TableRow>
                </TableBody>

                <TableBody>
                    {categories &&
                        categories.map((category) => {
                            const settingsArray = groupedSettings[category]
                            return (
                                <Fragment key={`sc_${category}`}>
                                    <TableRow>
                                        <TableCell
                                            m={1}
                                            p={0.5}
                                            colSpan={5}
                                            sx={{
                                                fontSize: "120%",
                                                backgroundColor: "#eee",
                                            }}
                                        >
                                            {category.replace("_", "").replace(/\./g, " / ")}
                                        </TableCell>
                                    </TableRow>
                                    <SettingsList settingsArray={settingsArray} />
                                </Fragment>
                            )
                        })}
                </TableBody>
            </Table>
        </TableContainer>
    )
}

function SettingsList({ settingsArray }) {
    settingsArray.sort((a, b) => {
        if (a._id < b._id) {
            return -1
        }
        if (a._id > b._id) {
            return 1
        }
        return 0
    })
    return <Repeat list={settingsArray} item={<SettingsRow />} pass="setting" bind />
}

/*
>*/
